import {
  LESS_984_MEDIA_QUERY,
  LESS_768_MEDIA_QUERY,
  LESS_1024_MEDIA_QUERY,
  LESS_1140_MEDIA_QUERY,
} from '../../../../consts/adaptive';

export const styles = {
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    gap: '24px 52px',
    width: '100%',

    [LESS_1140_MEDIA_QUERY]: {
      gap: '24px 12px',
    },

    [LESS_1024_MEDIA_QUERY]: {
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '1fr 1fr 1fr',
      gap: '24px',
    },

    [LESS_984_MEDIA_QUERY]: {
      gap: '24px 12px',
    },

    [LESS_768_MEDIA_QUERY]: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'repeat(6, 1fr)',
      gap: '24px',
    },
  },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
